import Reflection from "@/pages/client/reflection";
import Settings from "@/pages/account/settings";
import Journal from "@/pages/client/journal";
import ClientCourses from "@/pages/client/courses";
import CourseDetail from "@/pages/client/courses/detail";
import Faq from "@/pages/faq";
import PickThemes from "@/pages/account/pickThemes";
import clientProgressCharts from "@/pages/client/progress";
import dailyExercise from "@/pages/client/dailyExercises";
import clientDetailAssessments from "@/pages/client/assessments/detail";
import clientAssessments from "@/pages/client/assessments";
import clientGoals from "@/pages/client/goals";
import reflectionHistory from "@/pages/client/reflectionHistory";

import {
  authRoute,
  requireUser,
} from "./safeGuards";

const routes = [
  authRoute("/daily-exercise", dailyExercise, "DailyExercise"),
  authRoute('/reflection-history', reflectionHistory, "reflectionHistory"),
  authRoute("/courses", ClientCourses, "courses"),
  authRoute("/courses/:id", CourseDetail, "courseDetail", true),
  authRoute("/courses/:id/lesson/:lesson", CourseDetail, "lessonDetail", true),
  requireUser("/settings", Settings, "settings"),
  authRoute("/journal", Journal, "journal"),
  authRoute("/faq", Faq),
  authRoute("/pick-areas-of-focus", PickThemes, "pickThemes"),
  authRoute("/daily-reflection", Reflection, "dailyReflection"),
  authRoute("/daily-reflection/:id", Reflection, "dailyReflection"),
  authRoute("/pulse-survey/:id", Reflection, "pulseSurvey"),
  authRoute("/progress", clientProgressCharts, "progressCharts"),
  authRoute("/goals", clientGoals, "clientGoals"),
  authRoute("/c/assessments", clientAssessments, "clientAssessments"),
  authRoute("/c/assessments/:id", clientDetailAssessments, "clientAssessments"),
];

export default routes;
